import { LogoImg, LogoWrapper, ResponsiveLabel } from './StatusBarAppSwitch';
import { mb } from '../../Themes/utilities';
import { rem } from 'polished';
import Icon from '../../Icon';
import React from 'react';
import StatusBar from '../StatusBar';
import styled, { useTheme } from 'styled-components';
const LabelWrapper = styled.div `
  display: flex;
  flex-direction: column;
  ${mb('l')} {
    display: block;
  }
`;
const ContentDivider = styled.div `
  font-size: ${rem(11)};
`;
const StatusBarChildApp = ({ className, childApp, contentDivider, }) => {
    const theme = useTheme();
    let IconEl = null;
    if (childApp.logo) {
        IconEl = (React.createElement(LogoWrapper, { "$size": 24 },
            React.createElement(LogoImg, { src: childApp.logo, alt: childApp.name })));
    }
    else {
        IconEl = React.createElement(Icon, { size: "l", name: "apps", color: theme.color.primary });
    }
    return (React.createElement(StatusBar.Item, { className: className },
        IconEl,
        React.createElement(LabelWrapper, null,
            React.createElement(ResponsiveLabel, null, childApp.name),
            React.createElement(ContentDivider, null, contentDivider))));
};
export default StatusBarChildApp;
